import React from 'react';

const SvgAbstract44 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M16 16h-3v-5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H4V6.83L8.83 2h2.34L16 6.83zm3.71-8.29L12.29.29a1 1 0 0 0-.7-.29H8.41a1 1 0 0 0-.7.29L.29 7.71a1 1 0 0 0-.29.7V9.5a.5.5 0 0 0 .5.5H2v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4.75a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25V17a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-7h1.5a.5.5 0 0 0 .5-.5V8.41a1 1 0 0 0-.29-.7z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgAbstract44 svgRef={ref} {...props} />);
export default ForwardRef;
